var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindRoseText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 170,
    viewBox: "0 0 150 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Composant_25_49",
    "data-name": "Composant 25 \\u2013 49",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_59",
    "data-name": "Groupe 59",
    transform: "translate(77.099 31.109) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_54",
    "data-name": "Groupe 54",
    transform: "translate(19.492 -0.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143",
    "data-name": "Trac\\xE9 143",
    d: "M0,17.4S24.925-2.323,27.486.228,10.244,27.607,10.244,27.607H0Z",
    transform: "translate(-0.105 19.493) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_55",
    "data-name": "Groupe 55",
    transform: "translate(58.325 77.922) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143-2",
    "data-name": "Trac\\xE9 143",
    d: "M0,17.4S24.925-2.323,27.486.228,10.244,27.607,10.244,27.607H0Z",
    transform: "translate(-0.105 19.493) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_56",
    "data-name": "Groupe 56",
    transform: "translate(78.133 19.205) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143-3",
    "data-name": "Trac\\xE9 143",
    d: "M0,17.471S24.828-2.332,27.379.229,10.2,27.715,10.2,27.715H0Z",
    transform: "translate(0.106 19.627) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_57",
    "data-name": "Groupe 57",
    transform: "translate(-0.315 58.612) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143-4",
    "data-name": "Trac\\xE9 143",
    d: "M0,17.471S24.828-2.332,27.379.229,10.2,27.715,10.2,27.715H0Z",
    transform: "translate(0.106 19.627) rotate(-45)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    transform: "translate(46 55)",
    fill: "none",
    stroke: "#6c8cc0",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 31.5,
    rx: 31,
    ry: 31.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31,
    cy: 31.5,
    rx: 30,
    ry: 30.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_58",
    "data-name": "Groupe 58",
    transform: "translate(24.357 33.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_54-2",
    "data-name": "Groupe 54",
    transform: "translate(26.195 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143-5",
    "data-name": "Trac\\xE9 143",
    d: "M.174,23.585S33.593-2.943,37.039.5,13.957,37.368,13.957,37.368L.2,37.341Z",
    transform: "translate(0 26.262) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145",
    "data-name": "Trac\\xE9 145",
    d: "M34.252.184c3.061,3.134-22.185,34.067-22.185,34.067H.184S32.013,2.33,34.252.184Z",
    transform: "translate(2.226 26.602) rotate(-45)",
    fill: "#002395"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_55-2",
    "data-name": "Groupe 55",
    transform: "translate(79.287 105.047) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143-6",
    "data-name": "Trac\\xE9 143",
    d: "M.174,23.585S33.593-2.943,37.039.5,13.957,37.368,13.957,37.368L.2,37.341Z",
    transform: "translate(0 26.262) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145-2",
    "data-name": "Trac\\xE9 145",
    d: "M34.252.184c3.061,3.134-22.185,34.067-22.185,34.067H.184S32.013,2.33,34.252.184Z",
    transform: "translate(2.226 26.602) rotate(-45)",
    fill: "#6c8cc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_56-2",
    "data-name": "Groupe 56",
    transform: "translate(105.482 26.402) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143-7",
    "data-name": "Trac\\xE9 143",
    d: "M-.126,23.338S33.4-3.32,36.829.112,13.6,37.067,13.6,37.067l-13.756.027Z",
    transform: "translate(0 26.404) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145-3",
    "data-name": "Trac\\xE9 145",
    d: "M34.018-.183C37.067,2.939,11.7,33.971,11.7,33.971l-11.883.047S31.771,1.971,34.018-.183Z",
    transform: "translate(2.226 26.719) rotate(-45)",
    fill: "#6c8cc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_57-2",
    "data-name": "Groupe 57",
    transform: "translate(0 78.645) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_143-8",
    "data-name": "Trac\\xE9 143",
    d: "M-.126,23.338S33.4-3.32,36.829.112,13.6,37.067,13.6,37.067l-13.756.027Z",
    transform: "translate(0 26.404) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_145-4",
    "data-name": "Trac\\xE9 145",
    d: "M34.018-.183C37.067,2.939,11.7,33.971,11.7,33.971l-11.883.047S31.771,1.971,34.018-.183Z",
    transform: "translate(2.226 26.719) rotate(-45)",
    fill: "#6c8cc0"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "N",
    transform: "translate(76 19)",
    fill: "#002395",
    fontSize: 19,
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.336,
    y: 0
  }, "N")), /*#__PURE__*/React.createElement("text", {
    id: "S",
    transform: "translate(77 162)",
    fill: "#717171",
    fontSize: 21,
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.859,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(143 92)",
    fill: "#717171",
    fontSize: 21,
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.775,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "O",
    transform: "translate(7 92)",
    fill: "#717171",
    fontSize: 21,
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.214,
    y: 0
  }, "O")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindRoseText);
export default __webpack_public_path__ + "static/media/wind_rose_text.606f904d1d56f58bdb61106bfa0ecce7.svg";
export { ForwardRef as ReactComponent };